import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {

        // 查看/修改获取单条GET /api/SummerClass/GetById
        GetById(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.GoodsListNum = []
            $http.get("api/SummerClass/GetById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = Data
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress //收货地址
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话

                });
            });
        },


    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/SummerSchoolOrderView/services.js